import { render, staticRenderFns } from "./index.vue?vue&type=template&id=037d91e5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037d91e5')) {
      api.createRecord('037d91e5', component.options)
    } else {
      api.reload('037d91e5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=037d91e5", function () {
      api.rerender('037d91e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/localization/currencyManage/index.vue"
export default component.exports